import { AreaOutputDTO } from '@types';

export const AreaMapper = {
  toDTO: (data: Partial<AreaOutputDTO>): Partial<AreaOutputDTO> => {
    return {
      ...data,
    };
  },

  toView: (data: AreaOutputDTO): AreaOutputDTO => {
    return data; // Return the same object for now, can be expanded if needed
  },
}; 